import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/articles';

export default function HeroSection() {
  const featuredArticles = hotArticles.slice(0, 3);

  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20warm%20coral%20and%20dark%20charcoal%20gradients%2C%20geometric%20shapes%20floating%2C%20soft%20dramatic%20lighting%2C%20luxury%20editorial%20style%2C%20dark%20atmosphere%20with%20warm%20accents%2C%20minimalist%20abstract%20art%2C%20no%20text%2C%20smooth%20gradients%2C%20professional%20photography&width=1800&height=1200&seq=hero-bg-52chigua-01&orientation=landscape"
          alt="52吃瓜网 - 最新吃瓜爆料平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-screen-2xl mx-auto px-4 md:px-6 pt-32 pb-16 flex flex-col items-center text-center">
        {/* Main Title */}
        <div className="mb-8">
          <h1
            className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-background-50 leading-tight mb-4"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            最新吃瓜爆料
          </h1>
          <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-100/90" style={{ fontFamily: 'var(--font-heading)' }}>
            实时追踪热门大瓜
          </p>
          <p className="text-lg md:text-xl text-background-200/80 mt-4 font-light">
            网红黑料 · 明星塌房 · 每日更新
          </p>
        </div>

        {/* CTA Button */}
        <Link
          to="/category/remen-baoliao"
          className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 bg-accent-500 text-background-50 rounded-full text-base font-medium hover:bg-accent-600 transition-all hover:scale-105 cursor-pointer mb-16"
        >
          立即吃瓜
          <i className="ri-arrow-right-line"></i>
        </Link>

        {/* Featured Cards */}
        <div className="w-full max-w-5xl relative">
          <div className="flex flex-col md:flex-row items-center justify-center gap-0 md:gap-0">
            {featuredArticles.map((article, index) => {
              const isCenter = index === 1;
              return (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className={`group block w-full md:w-[300px] bg-background-50/95 backdrop-blur-sm rounded-xl overflow-hidden transition-all duration-300 hover:scale-105 cursor-pointer ${
                    isCenter
                      ? 'md:-mt-8 z-20 md:mx-0'
                      : index === 0
                      ? 'md:rotate-[-2deg] md:translate-x-4 z-10'
                      : 'md:rotate-[2deg] md:-translate-x-4 z-10'
                  }`}
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4">
                    <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full mb-2">
                      {article.category}
                    </span>
                    <h3 className="text-foreground-900 font-medium text-sm line-clamp-2 leading-snug">
                      {article.title}
                    </h3>
                    <div className="flex items-center gap-3 mt-2 text-foreground-500 text-xs">
                      <span><i className="ri-eye-line mr-1"></i>{(article.viewCount / 10000).toFixed(1)}万</span>
                      <span>{article.publishDate}</span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}